<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('商家')" prop="merchantId">
                <a-select v-model="queryParam.merchantId" :maxLength="32" :placeholder="$t('请选择')+$t('商家')" allow-clear>
                  <a-select-option v-for="item in merchantList" :key="item.id">{{ item.merchantName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="storeName">
                <span slot="label" ><a-tooltip>{{$t('门店名称')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.storeName" :maxLength="32" :placeholder="$t('请输入')+'门店名称'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item prop="storeMobile">
                <span slot="label" ><a-tooltip>{{$t('手机号')}}<template slot="title"><!--提示内容--> </template></a-tooltip> </span>
                <a-input v-model="queryParam.storeMobile" :maxLength="32" :placeholder="$t('请输入')+'手机号'" allow-clear @pressEnter="handleQuery"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                   :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                   :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                   valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd()" v-hasPermi="['merchant:merchantstore:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['merchant:merchantstore:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['merchant:merchantstore:remove']">
          <a-icon type="delete" />{{$t('删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['merchant:merchantstore:export']">
          <a-icon type="download" />{{$t('导出')}}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        v-table-sticky="{ fixedTop: 64 }"
        :scroll="{ x: '1200' }"
        id="draggable-table"
        class="draggable-table"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <template slot="storeLogo" slot-scope="text, record">
          <div>
            <img v-if="record.storeLogo" :src="record.storeLogo" style="width:50px;height:50px;" @click="handleRecordPreview(record.storeLogo)" alt="none"/>
          </div>
        </template>
        <span slot="storeStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.StatusEnum" :value="record.storeStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['merchant:merchantstore:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['merchant:merchantstore:edit']">
             <a-icon type="edit" />{{$t('修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantstore:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['merchant:merchantstore:remove']">
            <a-icon type="delete" />{{$t('删除')}}
          </a>
          <br>
          <a-divider type="vertical" v-hasPermi="['merchant:merchantstore:status']" />
          <a @click="handleOn(record)" v-if="record.storeStatus === 0 " v-hasPermi="['merchant:merchantstore:status']">
             <a-icon type="edit" />{{$t('启用')}}
          </a>
          <a @click="handleOff(record)"  v-if="record.storeStatus === 1 " v-hasPermi="['merchant:merchantstore:status']">
             <a-icon type="edit" />{{$t('禁用')}}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {pageMerchantStore, listMerchantStore, delMerchantStore, storeStatus} from '@/api/merchant/merchantStore'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import {listSelectMerchant, merchantStatus} from "@/api/merchant/merchantMerchant";

export default {
  name: 'MerchantStore',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      merchantList:[],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        merchantId: undefined,
        storeName: undefined,
        storeMobile: undefined,
        storeLogo: undefined,
        storeBackground: undefined,
        storeAddress: undefined,
        storeStatus: undefined,
        storeDescription: undefined,
        businessTime: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('编号'),
          dataIndex: 'id',
          align: 'center'
        },
        {
          title: this.$t('商家名称'),
          dataIndex: 'merchantName',
          align: 'center'
        },
        {
          title: this.$t('门店名称'),
          dataIndex: 'storeName',
          align: 'center'
        },
        {
          title: this.$t('门店logo'),
          dataIndex: 'storeLogo',
          scopedSlots: { customRender: 'storeLogo' },
          align: 'center'
        },
        {
          title: this.$t('手机号'),
          dataIndex: 'storeMobile',
          align: 'center'
        },
        /*{
          title: this.$t('商家背景图'),
          dataIndex: 'storeBackground',
          align: 'center'
        },*/
        {
          title: this.$t('门店所在地'),
          dataIndex: 'storeAreaxName',
          align: 'center'
        },
        {
          title: this.$t('门店地址'),
          dataIndex: 'storeAddress',
          align: 'center'
        },
       /* {
          title: this.$t('经度'),
          dataIndex: 'storeLongitude',
          align: 'center'
        },
        {
          title: this.$t('纬度'),
          dataIndex: 'storeLatitude',
          align: 'center'
        },*/
        {
          title: this.$t('门店状态'),
          dataIndex: 'storeStatus',
          scopedSlots: { customRender: 'storeStatus' },
          align: 'center'
        },
        /*{
          title: this.$t('商家简介'),
          dataIndex: 'storeDescription',
          align: 'center'
        },*/
        {
          title: this.$t('营业时间'),
          dataIndex: 'businessTime',
          align: 'center'
        },
       /* {
          title: this.$t('创建时间'),
          dataIndex: 'createTime',
          align: 'center'
        },*/
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '12%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.getMerchantList()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    /** 查询商家门店列表 */
    getList () {
      this.loading = true
     pageMerchantStore(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    getMerchantList () {
      listSelectMerchant({}).then(response => {
        this.merchantList = response.data
        if (this.userInfo.deptType === 2) {
          //添加一条记录,放到首位
          this.queryParam.merchantId = this.merchantList[0].id
        }
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        merchantId: undefined,
        storeName: undefined,
        storeMobile: undefined,
        storeLogo: undefined,
        storeBackground: undefined,
        storeAddress: undefined,
        storeStatus: undefined,
        storeDescription: undefined,
        businessTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleOn(record) {
      var that = this
      this.$confirm({
        title: '是否确认上架?',
        onOk () {
          return storeStatus({id:record.id,storeStatus: 1}).then(() => {
            that.onSelectChange([], [])
            const message = '上架成功'
            that.$message.success(message, 3)
            that.getList()
          })
        },
        onCancel () {}
      })
    },
    handleOff(record) {
      var that = this
      this.$confirm({
        title: '是否确认下架?',
        onOk () {
          return storeStatus({id:record.id,storeStatus: 0}).then(() => {
            that.onSelectChange([], [])
            const message = '下架成功'
            that.$message.success(message, 3)
            that.getList()

          })
        },
        onCancel () {}
      })
    },
    handleAdd() {
      if (this.queryParam.merchantId) {
        this.$refs.createForm.handleAdd(this.queryParam.merchantId);
      } else {
        this.$message.error("请先选择商家",3)
      }

    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      let reqData = {"idList":this.ids}
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delMerchantStore(reqData)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(message,3)
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('biz/admin/merchant/store/export',
            that.queryParam
          , `商家门店_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
